import { Standard } from '@getvim/vim-connect';

export const SELECT_ACTION: string = 'Select action';
export let sortedActions: any[] = Object.keys(Standard.Actions.ActionNames)
  .sort()
  .map((key: string) => Standard.Actions.ActionNames[key]);
sortedActions = [SELECT_ACTION, ...sortedActions];
